<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(status)="data">
      <span :class="{'text-danger': data.item.status === 'Deleted', 'text-success': data.item.status === 'Active'}">
        {{ data.item.status }}
      </span>
    </template>
    <template #cell(level)="data">
      <template v-if="!data.item.level">Default</template>
      <span v-else-if="data.item.level === 'info'" class="info-color">Info</span>
      <span v-else-if="data.item.level === 'success'" class="success-color">Success</span>
      <span v-else-if="data.item.level === 'warning'" class="warning-color">Warning</span>
      <span v-else-if="data.item.level === 'error'" class="error-color">Error</span>
    </template>
    <template #cell(start_date)="data">
      <template v-if="!data.item.start_date">-</template>
      <template v-else>{{ convertFromUtc(data.item.start_date, 'L') }}</template>
    </template>
    <template #cell(end_date)="data">
      <template v-if="!data.item.end_date">-</template>
      <template v-else>{{ convertFromUtc(data.item.end_date, 'L') }}</template>
    </template>
    <template #cell(created_by)="data">
      <b-link v-if="data.item.created_by" :to="{name: 'admin-user', params: {id: data.item.created_by.id}}">
        {{ data.item.created_by.name }}
      </b-link>
    </template>
    <template #cell(actions)="data">
      <b-btn
        v-if="!data.item.is_deleted"
        variant="secondary"
        @click="$emit('edit-clicked', data.item.id)"
      >
        Edit
      </b-btn>
      <no-permission-wrapper :show="!canDeleteNotifications">
        <b-btn
          v-if="!data.item.is_deleted"
          variant="danger"
          @click="$emit('delete-clicked', data.item.id)"
          :disabled="!canDeleteNotifications"
        >
          Delete
        </b-btn>
      </no-permission-wrapper>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";
import NoPermissionWrapper from "./NoPermissionWrapper.vue";

export default {
  name: "AdminAppNotificationsTable",
  components: {NoPermissionWrapper},
  emit: ['edit-clicked', 'delete-clicked'],
  props: {
    notifications: Array
  },
  data() {
    return {
      fields: [
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "level",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "title",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "start_date",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "end_date",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "created_by",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "actions",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        }
      ]
    }
  },
  methods: {
    convertFromUtc,
    onClickRow(item) {
      this.$emit('edit-clicked', item.id);
    }
  },
  computed: {
    canDeleteNotifications() {
      return this.$store.getters['auth/hasAdminPermissions']('app_notification_delete');
    },
    items() {
      return this.notifications.map(notification => ({
        id: notification.id,
        level: notification.level,
        status: notification.is_deleted ? 'Deleted' :
            (notification.is_active) ? 'Active' : 'Inactive',
        title: notification.title,
        content: notification.content,
        start_date: notification.start_date,
        end_date: notification.end_date,
        created_by: notification.created_by,
        is_deleted: notification.is_deleted,
      }));
    }
  }
}
</script>

<style lang="scss" scoped>
.error-color {
  color: #C62828 !important;
}
.warning-color {
  color: #EF6C00 !important;
}
.info-color {
  color: #1565C0 !important;
}
.success-color {
  color: #2E7D32 !important;
}
</style>
